module.exports = __webpack_public_path__ + "img/246x2462.7cc1f41f.png";